export default {"src":"/_next/static/media/verified-blue.70b807b4.svg","height":23,"width":22};